import { render, staticRenderFns } from "./BlogPasswordDialog.vue?vue&type=template&id=2940ea28&scoped=true&"
import script from "./BlogPasswordDialog.vue?vue&type=script&lang=js&"
export * from "./BlogPasswordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2940ea28",
  null
  
)

export default component.exports